import { useDownloadActivityFeedSnapshotMutation } from '../../../services/modules/activityFeed/activityFeed.mutations';
import type { DownloadActivityFeedSnapshotParams } from '../../../services/modules/activityFeed/activityFeed.types';
import DownloadCsvButton from './DownloadCsvButton/DownloadCsvButton';

interface ActivityFeedSnapshotDownloadProps extends DownloadActivityFeedSnapshotParams {
  testId?: string;
}

const ActivityFeedSnapshotDownload = ({
  eventId,
  snapshotKind,
  filename,
  testId,
}: ActivityFeedSnapshotDownloadProps) => {
  const { isPending, downloadSnapshot } = useDownloadActivityFeedSnapshotMutation();

  return (
    <DownloadCsvButton
      isDisabled={isPending}
      testId={testId}
      onClick={() => downloadSnapshot({ eventId, snapshotKind, filename })}
    />
  );
};

export default ActivityFeedSnapshotDownload;
